// extracted by mini-css-extract-plugin
export default {"box":"Login_box__UsSMU","avatar":"Login_avatar__n6iv1","form":"Login_form__xawx9","botao":"Login_botao__bAp5a"};